/**
 * UR Coupon Capture
 * Reads ?cupom= / ?coupon= / ?discount= from any landing URL, redirects through
 * Shopify's native /discount/CODE endpoint so the cookie is set and the discount
 * auto-applies at checkout. Also persists the code in sessionStorage so the
 * first-purchase popup knows to stay quiet for that visit.
 */
(function () {
  try {
    var qs = new URLSearchParams(window.location.search);
    var code =
      qs.get('cupom') ||
      qs.get('coupon') ||
      qs.get('discount') ||
      qs.get('cupon');

    if (!code) return;

    code = code.trim().toUpperCase();
    if (!/^[A-Z0-9_-]{2,32}$/.test(code)) return;

    // Already on /discount/ — Shopify is handling it; just persist and stop.
    if (/^\/discount\//i.test(window.location.pathname)) {
      try { sessionStorage.setItem('ur_referral_code', code); } catch (e) { /* noop */ }
      return;
    }

    try {
      sessionStorage.setItem('ur_referral_code', code);
      localStorage.setItem('ur_referral_code', code);
      localStorage.setItem('ur_referral_code_at', String(Date.now()));
    } catch (e) { /* noop */ }

    // Analytics
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'referral_code_captured',
        referral_code: code
      });
    } catch (e) { /* noop */ }

    // Build a clean redirect target (preserve path + remaining params, drop the coupon ones)
    qs.delete('cupom');
    qs.delete('coupon');
    qs.delete('discount');
    qs.delete('cupon');
    var cleanQuery = qs.toString();
    var redirectPath = window.location.pathname + (cleanQuery ? '?' + cleanQuery : '') + window.location.hash;

    var target = '/discount/' + encodeURIComponent(code) +
      '?redirect=' + encodeURIComponent(redirectPath);

    window.location.replace(target);
  } catch (e) {
    /* fail silently — never break the page over a coupon */
  }
})();
